
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { isValidPartner } from '@circlefin/components';
import { logger } from '@circlefin/logger';
import { buildConnectUrl, isLegacyRequest, isSsoCompletionRequest, } from '@features/auth/constants';
import { SignIn } from '@features/auth/containers';
import { MINT_SIGNIN_REDIRECT_ENABLED, PARTNER_SSO_LOGIN_ENABLED, } from '@services/permissions';
import { permissionsCheck } from '@services/permissions/check';
import { createLDContextFromSession, getSyntheticRoles, } from '@services/synthetic-roles/lib';
import { AuthLayout } from '@shared/layout';
import { AppPage } from '@shared/layout/core';
import type { Partner } from '@circlefin/components/lib/CoBrandingLogo';
import type { AppComponentProps } from '@shared/layout/core';
import type { GetServerSideProps, InferGetServerSidePropsType, } from 'next/types';
export interface SignInProps extends AppComponentProps {
    /**
     * Partner.
     */
    partner?: Partner;
}
/**
 * Default No Session Page.
 */
const SignInPage: React.FC<InferGetServerSidePropsType<typeof getServerSideProps>> = ({ partner }) => {
    return <SignIn partner={partner}/>;
};
export default AppPage(SignInPage, {
    getLayout: (page) => <AuthLayout>{page}</AuthLayout>
});
const getServerSideProps: GetServerSideProps<SignInProps> = async (context) => {
    const synthRoles = await getSyntheticRoles(createLDContextFromSession(null));
    const check = permissionsCheck(null, synthRoles);
    // Hand the page over to auth-web's unified sign-in while the redirect role is
    // on, unless this request opted out with `?legacy=true` or is Okta handing an
    // SSO sign-in back, which only this page completes. A missing or malformed
    // CIRCLE_AUTH_URL leaves the legacy page serving rather than redirecting
    // nowhere.
    if (!isLegacyRequest(context.query) &&
        !isSsoCompletionRequest(context.query)) {
        const { isAuthorized } = await check(MINT_SIGNIN_REDIRECT_ENABLED);
        const destination = isAuthorized
            ? buildConnectUrl(process.env.CIRCLE_AUTH_URL, context.query)
            : null;
        if (destination) {
            return { redirect: { destination, permanent: false } };
        }
        if (isAuthorized) {
            logger.warn('[signin] CIRCLE_AUTH_URL is missing or not a usable auth-web origin; /connect redirect skipped');
        }
    }
    const partnerSsoLoginPermission = await check(PARTNER_SSO_LOGIN_ENABLED);
    const partner = partnerSsoLoginPermission.isAuthorized &&
        isValidPartner(context.query.partner)
        ? context.query.partner
        : undefined;
    return { props: { partner } };
};

    async function __Next_Translate__getServerSideProps__1a1843277a0__(ctx) {
      const res = await getServerSideProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/signin',
            loaderName: 'getServerSideProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getServerSideProps__1a1843277a0__ as getServerSideProps }
  